import { COUNTRIES } from '../countries'
import * as V from '../vocab'

export interface VocabEntry {
  value: string
  label: string
}

function entries<T extends string>(v: V.Vocab<T>): VocabEntry[] {
  return v.values.map((value) => ({ value, label: v.labels[value] }))
}

/** Public form vocabularies served by `GET /api/v1/meta/vocabularies`. */
export const PUBLIC_VOCABULARIES = {
  findings: V.FINDINGS,
  priorities: V.PRIORITIES,
  stages: V.STAGES,
  mapping_states: V.MAPPING_STATES,
  source_classes: V.SOURCE_CLASSES,
  sharing: V.SHARING,
  engagement_statuses: V.ENGAGEMENT_STATUSES,
  search_run_states: V.SEARCH_RUN_STATES,
  dialogue_event_types: V.DIALOGUE_EVENT_TYPES,
  meeting_types: V.MEETING_TYPES,
  participation_request_types: V.PARTICIPATION_REQUEST_TYPES,
  participation_states: V.PARTICIPATION_STATES,
  client_actions: V.CLIENT_ACTIONS,
  severities: V.SEVERITIES,
  confidence_levels: V.CONFIDENCE_LEVELS,
  involvement_types: V.INVOLVEMENT_TYPES,
  themes: V.THEMES,
  event_types: V.EVENT_TYPES,
  sectors: V.SECTORS,
  countries: COUNTRIES,
  rights_basis: V.RIGHTS_BASIS,
  redistribution: V.REDISTRIBUTION,
  security_identifier_types: V.SECURITY_IDENTIFIER_TYPES,
  issuer_identifier_types: V.ISSUER_IDENTIFIER_TYPES,
  date_precisions: V.DATE_PRECISIONS,
  review_states: V.REVIEW_STATES,
  meeting_states: V.MEETING_STATES,
  question_statuses: V.QUESTION_STATUSES,
  saved_view_scopes: V.SAVED_VIEW_SCOPES,
  coverage_labels: V.COVERAGE_LABELS,
} as const

export type VocabularyName = keyof typeof PUBLIC_VOCABULARIES

export function vocabulariesPayload(): Record<VocabularyName, VocabEntry[]> {
  const out = {} as Record<VocabularyName, VocabEntry[]>
  for (const [name, v] of Object.entries(PUBLIC_VOCABULARIES) as [
    VocabularyName,
    V.Vocab<string>,
  ][]) {
    out[name] = entries(v)
  }
  return out
}
